/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'src/redux/index';
import { unlockSolution } from 'src/components/SharedLayout/actions';
import type { AnsweredQuestionResponse, GetSkillsResponse } from 'src/openapi';
import { getAnsweredQuestions } from 'src/redux/actions/candidateLayout';

type Filter = {
  skill: GetSkillsResponse | null;
  pageNo: number;
  pageSize: number;
  filterType?: string;
};

interface QuestionHistoryState {
  filter: Filter;
  answeredQuestion?: AnsweredQuestionResponse;
  isFetchingQuestions?: boolean;
}

const initialState: QuestionHistoryState = {
  filter: { skill: null, pageNo: 1, pageSize: 10 },
};

const questionHistorySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<Filter>) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAnsweredQuestions.pending, (state) => {
      state.isFetchingQuestions = true;
    });
    builder.addCase(getAnsweredQuestions.fulfilled, (state, action) => {
      state.answeredQuestion = action.payload;
      state.isFetchingQuestions = false;
    });
    builder.addCase(getAnsweredQuestions.rejected, (state) => {
      state.isFetchingQuestions = false;
    });
    builder.addCase(unlockSolution.fulfilled, (state, action) => {
      if (state?.answeredQuestion?.all_attempts) {
        state.answeredQuestion.all_attempts =
          state.answeredQuestion?.all_attempts?.map((attempt) => {
            if (
              attempt.question_id === action.payload.question_id &&
              attempt.question
            ) {
              attempt.is_solution_unlocked = true;
            }
            return attempt;
          });
      }
    });
  },
});

export const { setFilter } = questionHistorySlice.actions;
export const questionHistorySelector = (state: RootState) =>
  state.questionHistory;

export default questionHistorySlice.reducer;
